export const ERROR_LOGGING_PAGES = ['/share/', '/embed/']
